import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput as DocUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { PaginatedAutocomplete } from '@ifca-root/react-component/src/containers/ComponentModule/PaginatedAutoComplete'
import { changeDateFormat } from '@ifca-root/react-component/src/helpers/Functions/dateFunction'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { CircularProgress, MenuItem, TextField } from '@material-ui/core'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import {
  AddFavoriteDialog,
  DeleteFavoriteDialog,
} from 'components/Favorite/FavoriteDialog'
import FavoriteMenu from 'components/Favorite/FavoriteMenu'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import { PaymentAllocationTableContent } from 'components/Table/PaymentAllocationTableContent'
import { DropdownTextfield } from 'containers/ARAPModule/Components/DropdownTextField'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  DocumentListingDocument,
  GetApFavoritePaymentDocument,
  GetApPaymentbyStatusDocument,
  RecordStatus,
  useCreateApFavoritePaymentMutation,
  useCreateApPaymentMutation,
  useDeleteApFavoritePaymentMutation,
  useDocumentListingLazyQuery,
  useGetApAllocationDocumentLazyQuery,
  useGetApFavoritePaymentQuery,
  useGetBankAccountLazyQuery,
  useGetCreditCardTypeLazyQuery,
  useGetCreditorAccountCompanyAssignmentLazyQuery,
  useGetCreditorAccountCompanyAssignmentPaginatedListingLazyQuery,
  useGetCreditorOsAmtLazyQuery,
  useGetDocNumTitleQuery,
  useGetDocumentDateValidationQuery,
  useGetPaymentMethodLazyQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateApPaymentMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  getDatePlusDay,
} from 'helpers/StringNumberFunction/FormatDate'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import '../APPayment.scss'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
import InfiniteScroll from 'react-infinite-scroll-component'

interface APPaymentProps {
  CompanyID: string
  CreditorAccountID: string
  PaymentID: string
  DocDate: string
  TrxDate: string
  DocAmt: number
  RefNo: string
  Description: string
  Remark: string
  Attachment: null
  debitAmt: number
  approval: string
  user: string
  BankAccountID: string
  BankName: string
  PaymentMethodID: string
  CreditCardID: string
  ChequeNo: string
  ChequeDate: Date
  uploadAttach: string
  Allocation: any[]
}
interface FavAPPaymentProps {
  Name: string
}

interface AllocationInput {
  CreditID: string
  CreditOrDebit: 'Credit' | 'Debit'
  CreditRefTable: string
  DebitID: string
  DebitRefTable: string
  DocDate: string
  DocAmt: number
  BalanceAmt: number
  IsChecked?: boolean
  AllocationID?: string
  AllocationAmt: number
}

interface AllocationOutput {
  CompanyID: string
  CreditID: string
  DebitID: string
  CreditRefTable: string
  DebitRefTable: string
  SourceID: string
  AllocationID?: string
  AllocationAmt: number
  SourceRefTable: string
}

export const APPaymentForm = (props: any) => {
  useEffect(() => {
    document.title = 'AP - Payment'
  }, [])

  const { formMode, type } = props
  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  /* -------------------------------------------- */
  /*               STATE & VARIABLES              */
  /* -------------------------------------------- */
  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any
  const { CompanyID, PaymentID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [docAmt, setDocAmt] = useState(0)

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [openExitDialog, setopenExitDialog] = useState(false)
  const [PaymentValidation, setPaymentValidation] = useState(false)
  const [valuepicked, setValuePicked] = useState<String>(null)
  const [isSubmit, setIsSubmit] = useState(false)
  const [skip, setSkip] = useState(0)
  const take = 20
  const [hasMore, setHasMore] = useState(true)

  // Change Tax descrition into code number
  const [openExitConf, setOpenExitConf] = useState(null)
  const [val, setVal] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [allocatedObj, setAllocatedObj] = useState({})
  const [initDocs, setInitDocs] = useState([])
  useEffect(() => {
    if (editData?.Attachment) {
      setInitDocs(editData?.Attachment)
    }
  }, [editData])
  const [record, setRecord] = useState(false)
  const [voiceRemark, setVoiceRemark] = useState('')
  const [openFavoriteDialog, setOpenFavoriteDialog] = useState(false)
  const [openFavoriteDeleteDialog, setOpenFavoriteDeleteDialog] = useState(
    false
  )
  const [creditorAccID, setCreditorAccID] = useState(
    editData ? editData?.CreditorAccountID : null
  )
  const [paymentMethodID, setPaymentMethodID] = useState(
    editData ? editData?.PaymentMethodID : null
  )
  const [creditCardID, setCreditCardID] = useState(
    editData ? editData?.CreditCardID : null
  )
  const [bankAccountID, setBankAccountID] = useState(
    editData ? editData?.BankAccountID : null
  )
  const [creditorAccounts, setCreditorAccounts] = useState([])
  const [totalCreditorAccounts, setTotalCreditorAccounts] = useState(0)
  const [refresh, setRefresh] = useState(!!editData?.CreditorAccountID)

  const {
    anchorEl: anchorElFav,
    setAnchorEl: setAnchorElFav,
    menu: menuFav,
    handleClick: handleClickFav,
    handleClose: handleCloseFav,
  } = useMenuOption()

  /* -------------------------------------------- */
  /*               QUERY & MUTATION               */
  /* -------------------------------------------- */

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const [
    fetchGetCreditorAccountCompanyAssignmentPaginatedListing,
    {
      loading: FetchGetCreditorAccountCompanyAssignmentPaginatedLoading,
      data: { getCreditorAccountCompanyAssignmentPaginatedListing } = {
        getCreditorAccountCompanyAssignmentPaginatedListing: {},
      },
    },
  ] = useGetCreditorAccountCompanyAssignmentPaginatedListingLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: () => {
      setCreditorAccounts(prev => [
        ...prev,
        ...getCreditorAccountCompanyAssignmentPaginatedListing?.Data.map(
          data => data?.CreditorAccount
        ),
      ])

      setTotalCreditorAccounts(
        getCreditorAccountCompanyAssignmentPaginatedListing?.TotalLength
      )
      setRefresh(false)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID,
      skip: 0,
      take: 50,
    },
  })

  const [
    creditorOsAmt,
    {
      loading: CreditorTotalDocAmtLoading,
      called: CreditorTotalDocAmtCalled,
      data: { getCreditorOSAmt } = { getCreditorOSAmt: 0 },
    },
  ] = useGetCreditorOsAmtLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (creditorAccID)
      creditorOsAmt({
        variables: {
          CompanyID: CompanyID,
          CreditorAccountID: creditorAccID ?? editData?.CreditorAccountID,
        },
      })
  }, [creditorAccID])

  const [
    fetchPaymentMethod,
    {
      loading: PaymentMethodLoading,
      error: PaymentMethodError,
      data: { getPaymentMethod } = { getPaymentMethod: [] },
    },
  ] = useGetPaymentMethodLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  const [
    fetchBankAccount,
    {
      loading: bankAccountLoading,
      data: { getBankAccount } = { getBankAccount: [] },
    },
  ] = useGetBankAccountLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  const {
    loading: docNumHeaderLoading,
    error: docNumHeaderError,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'AP_Payment',
    },
  })

  const [
    fetchCreditCardType,
    {
      loading: CreditCardTypeLoading,
      error: CreditCardTypeError,
      data: { getCreditCardType } = { getCreditCardType: [] },
    },
  ] = useGetCreditCardTypeLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  //Favorite Payment Query
  let favNames
  const {
    loading: FavoritePaymentLoading,
    error: FavoritePaymentError,
    data: { getAPFavoritePayment } = { getAPFavoritePayment: [] },
  } = useGetApFavoritePaymentQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      UserID: user?.ID,
    },
    onCompleted: ({ getAPFavoritePayment }) => {
      favNames = getAPFavoritePayment?.map(x => x?.Name)
    },
  })

  const [
    createAPFavoritePayment,
    {
      loading: createAPFavoritePaymentLoading,
      error: createAPFavoritePaymentError,
    },
  ] = useCreateApFavoritePaymentMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setOpenFavoriteDialog(false)
    },
  })

  const [
    deleteAPFavoritePayment,
    {
      loading: deleteAPFavoritePaymentLoading,
      error: deleteAPFavoritePaymentError,
    },
  ] = useDeleteApFavoritePaymentMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOpenFavoriteDeleteDialog(false)
    },
    variables: {
      FavoritePaymentID: menuFav?.ID,
    },
  })

  const [
    createAPPayment,
    {
      loading: createAPPaymentLoading,
      called: createAPPaymentCalled,
      error: createAPPaymentError,
    },
  ] = useCreateApPaymentMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: ({ createAPPayment }) => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      // setTimeout(() => {
      if (!!isSubmit) {
        history.push({
          pathname: `/account-payable/${CompanyID}/payment/${createAPPayment?.PaymentID}/preview`,
        })
      } else {
        history.push({
          pathname: `/account-payable/${CompanyID}/payment`,
          state: { success: true, msgMode: 'create' },
        })
      }
      // }, 500)
    },
  })

  const [
    updateAPPayment,
    {
      loading: updateAPPaymentLoading,
      called: updateAPPaymentCalled,
      error: updateAPPaymentError,
    },
  ] = useUpdateApPaymentMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      // setTimeout(() => {
      if (!!isSubmit) {
        history.push({
          pathname: `/account-payable/${CompanyID}/payment/${PaymentID ??
            updateAPPayment?.PaymentID}/preview`,
        })
      } else {
        history.push({
          pathname: `/account-payable/${CompanyID}/payment`,
          state: { success: true, msgMode: 'update' },
        })
      }
      // }, 500)
    },
  })

  const [
    loadAllocationDocument,
    {
      loading: getAllocationDocumentLoading,
      called: getAllocationDocumentCalled,
      error: getAllocationDocumentError,
      data: { getAllocationDocument } = { getAllocationDocument: [] },
    },
  ] = useGetApAllocationDocumentLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: ({ getAllocationDocument }) => {
      let arr = []
      if (getAllocationDocument?.length > 0) {
        getAllocationDocument?.map((alloc, index) => {
          arr.push({
            AllocationID: alloc?.AllocationID,
            CreditOrDebit: alloc?.CreditOrDebit,
            DocDate: alloc?.DocDate,
            DocNo: alloc?.DocNo,
            Description: alloc?.Description,
            // for previous allocated amt on the same doc
            AllocationAmt: Number(
              allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0
            ),
            // balance amount + previous allocated amt on the same doc
            BalanceAmt:
              parseFloat(alloc?.BalanceAmt) +
              Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0),
            // credit or debit id
            [`${alloc?.CreditOrDebit}ID`]: alloc[`${alloc?.CreditOrDebit}ID`],
            // credit or debit ref table
            [`${alloc?.CreditOrDebit}RefTable`]: alloc[
              `${alloc?.CreditOrDebit}RefTable`
            ],
            // credit or debit doc no
            [`${alloc?.CreditOrDebit}DocNo`]: alloc[
              `${alloc?.CreditOrDebit}DocNo`
            ],
          })

          return alloc
        })
        append(arr)
        setSkip(prev => prev + getAllocationDocument.length)

        // Kalau dapat kurang dari take, maksudnya dah last page
        if (getAllocationDocument.length < take) {
          setHasMore(false)
        }
      } else {
        // Kalau kosong, memang takde lagi data
        setHasMore(false)
      }
    },
  })

  /* -------------------------------------------- */
  /*                    USEFORM                   */
  /* -------------------------------------------- */
  const APPaymentFormSchema = yup.object().shape({
    DocDate: yup.string().required('Doc Date is Required'),
    TrxDate: yup.string().required('Transaction Date is Required'),
    RefNo: CommonYupValidation.requireField(SystemMsgs.referenceNo()),
    CreditorAccountID: yup.string().required('Creditor Name is required'),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    PaymentMethodID: CommonYupValidation.requireField(
      'Payment Method is required'
    ),
    CreditCardID:
      PaymentValidation && valuepicked?.includes('Card')
        ? CommonYupValidation.requireField('Credit Card Type is required')
        : null,
    ChequeNo: yup.string().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.string().required('Cheque no. is required'),
      otherwise: null,
    }),
    ChequeDate: yup.date().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.date().required('Cheque date is required'),
      otherwise: null,
    }),

    BankAccountID: CommonYupValidation.requireField(
      'Bank Account No. is required'
    ),
    Allocation: yup.array().of(
      yup.object().shape({
        AllocationAmt: CommonYupValidation?.requireField(
          'Allocation Amt is required'
        ).nullable(),
      })
    ),
    // TaxRate: yup.string().required('Tax Rate is Required'),
  })

  const FavAPPaymentFormSchema = yup.object().shape({
    Name: CommonYupValidation.requireField(SystemMsgs.name()),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    getValues,
    clearErrors,
    setError,
  } = useForm<APPaymentProps>({
    defaultValues: {
      CreditorAccountID: editData ? editData?.CreditorAccountID : '',
      CompanyID: editData ? editData?.CompanyID : '',
      DocDate: editData ? editData?.DocDate : new Date(),
      TrxDate: editData ? editData?.TransactionDate : new Date(),
      RefNo: editData ? editData?.RefNo : '',
      BankAccountID: editData ? editData?.BankAccountID : '',
      PaymentMethodID: editData ? editData?.PaymentMethodID : '',
      ChequeNo: editData ? editData?.ChequeNo : '',
      ChequeDate: editData ? editData?.ChequeDate : new Date(),
      DocAmt: editData ? editData?.DocAmt : 0,
      Description: editData ? editData?.Description : '',
      Remark: editData ? editData?.Remark : '',
      Attachment: editData ? editData?.Attachment : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(APPaymentFormSchema),
  })

  const {
    handleSubmit: handleFavSubmit,
    register: favRegister,
    control: favControl,
    errors: favErrors,
    watch: favWatch,
  } = useForm<FavAPPaymentProps>({
    mode: 'onSubmit',
    resolver: yupResolver(FavAPPaymentFormSchema),
  })

  const onSubmit = (data, status) => {
    if (val == false) {
      setVal(true)

      // date formatting function
      const formatDateForAPI = dateValue => {
        if (!dateValue) return null
        const date = new Date(dateValue)
        return isNaN(date.getTime()) ? null : formatDashDate(date.toISOString())
      }

      if (formMode === 'add') {
        createAPPayment({
          variables: {
            input: {
              CompanyID: CompanyID,
              DocDate: formatDateForAPI(data?.DocDate),
              TransactionDate: formatDateForAPI(data?.TrxDate),
              RefNo: data?.RefNo,
              CreditorAccountID: data?.CreditorAccountID,
              PaymentMethodID: data?.PaymentMethodID,
              CreditCardID: data?.CreditCardID,
              ChequeNo: data?.ChequeNo,
              ChequeDate: formatDateForAPI(data?.ChequeDate),
              ChequeExpiryDate: data?.ChequeDate
                ? formatDateForAPI(getDatePlusDay(data?.ChequeDate, 180))
                : null,
              BankAccountID: data?.BankAccountID,
              Description: data?.Description,
              Remark: data.Remark,
              ApprovalStatus: statusInput(status),
              Amount: docAmt,
              DocAmt: docAmt,
              Attachment: files,
            },
            allocationInput: allocateFIFO(
              watch('Allocation')?.filter(
                alloc =>
                  Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
              ) || []
            ),
            // ?.map(alloc => {
            //   const mainCreditOrDebit =
            //     alloc?.CreditOrDebit === 'Debit' ? 'Credit' : 'Debit'
            //   return {
            //     ...(alloc?.AllocationID
            //       ? { AllocationID: alloc?.AllocationID }
            //       : null),
            //     AllocationAmt: Number(alloc?.AllocationAmt),
            //     CreditOrDebit: alloc?.CreditOrDebit,
            //     CompanyID: CompanyID,
            //     // for allocated table
            //     [`${alloc?.CreditOrDebit}RefTable`]: alloc?.[
            //       `${alloc?.CreditOrDebit}RefTable`
            //     ],
            //     [`${alloc?.CreditOrDebit}ID`]: alloc?.[
            //       `${alloc?.CreditOrDebit}ID`
            //     ],
            //     // main table
            //     [`${mainCreditOrDebit}RefTable`]: 'AP_Payment',
            //   }
            // }),
          },
          refetchQueries: [
            {
              query: GetApPaymentbyStatusDocument,
              variables: {
                CompanyID: CompanyID,
                StatusArr: ['ACTIVE'],
              },
            },
            {
              query: DocumentListingDocument,
              variables: {
                refTable: 'S_Attachment',
                refID: editData?.PaymentID,
              },
            },
          ],
        })
        // }
      } else if (formMode !== 'add') {
        updateAPPayment({
          variables: {
            input: {
              CompanyID: CompanyID,
              PaymentID: PaymentID,
              DocDate: formatDateForAPI(data?.DocDate),
              TransactionDate: formatDateForAPI(data?.TrxDate),
              RefNo: data?.RefNo,
              CreditorAccountID: data?.CreditorAccountID,
              PaymentMethodID: data?.PaymentMethodID,
              CreditCardID: data?.CreditCardID,
              ChequeNo: data?.ChequeNo,
              ChequeDate: formatDateForAPI(data?.ChequeDate),
              ChequeExpiryDate: data?.ChequeDate
                ? formatDateForAPI(getDatePlusDay(data?.ChequeDate, 180))
                : null,
              BankAccountID: data?.BankAccountID,
              Description: data?.Description,
              Remark: data.Remark,
              ApprovalStatus: statusInput(status),
              Amount: docAmt,
              DocAmt: docAmt,
              Attachment: files,
            },
            allocationInput: allocateFIFO(
              watch('Allocation')?.filter(
                alloc =>
                  Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
              ) || [],
              editData?.PaymentID
            ),
          },
          refetchQueries: [
            {
              query: GetApPaymentbyStatusDocument,
              variables: {
                CompanyID: CompanyID,
                StatusArr: ['ACTIVE'],
              },
            },
            {
              query: DocumentListingDocument,
              variables: {
                refTable: 'S_Attachment',
                refID: editData?.PaymentID,
              },
            },
          ],
        })
      }
    }
  }

  const favRefetchQuery = [
    {
      query: GetApFavoritePaymentDocument,
      variables: {
        CompanyID: CompanyID,
        UserID: user?.ID,
      },
    },
  ]

  const onSubmitFavorite = data => {
    const tempFav = {
      UserID: user?.ID,
      CompanyID: CompanyID,
      Name: data?.Name,
      RefNo: !!getValues('RefNo') ? getValues('RefNo') : null,
      CreditorAccountID: !!getValues('CreditorAccountID')
        ? getValues('CreditorAccountID')
        : null,
      PaymentMethodID: !!getValues('PaymentMethodID')
        ? getValues('PaymentMethodID')
        : null,
      CreditCardID: !!getValues('CreditCardID')
        ? getValues('CreditCardID')
        : null,
      BankAccountID: !!getValues('BankAccountID')
        ? getValues('BankAccountID')
        : null,
      Description: !!getValues('Description') ? getValues('Description') : null,
      Remark: !!getValues('Remark') ? getValues('Remark') : null,
    }

    createAPFavoritePayment({
      variables: {
        APFavoritePaymentInput: tempFav,
      },
      refetchQueries: favRefetchQuery,
    })
  }

  let statusInput = mode => {
    let temp
    switch (mode) {
      case 'submit':
        temp = ApprovalStatus.Submit
        break
      case 'draft':
        temp = ApprovalStatus.Active
        break
      case 'approve':
        temp = ApprovalStatus.Approved
        break
      case 'reject':
        temp = ApprovalStatus.Rejected
        break
    }
    return temp
  }

  const createUpdateLoading = editData
    ? updateAPPaymentLoading
    : createAPPaymentLoading

  const createUpdateCalled = editData
    ? updateAPPaymentCalled
    : createAPPaymentCalled

  const { fields, append, remove, prepend } = useFieldArray({
    control,
    name: 'Allocation',
  })

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */

  const [selectedBank, setSelectedBank] = useState(null)
  // select bank
  const handleBankChange = event => {
    setSelectedBank(
      getBankAccount.find(x => x?.BankAccountID === event?.target?.value)
    )
  }

  const handlePMChange = event => {
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque' ||
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setPaymentValidation(true)
    } else setPaymentValidation(false)
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque'
    ) {
      setValuePicked('Cheque')
    } else if (
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setValuePicked('Card')
    } else setValuePicked('')
  }

  //Changing If PM chosed CreditCard
  const [selectedCC, setSelectedCC] = useState(null)
  const creditcard: any = getCreditCardType

  const handleCCChange = event => {
    setSelectedCC(
      creditcard.find(x => x?.CreditCardID === event?.target?.value)
    )
  }

  const handleCreditorDebtorChange = event => {
    remove()
    loadAllocationDocument({
      variables: {
        ...(editData && editData?.CreditorAccountID === event
          ? { entityID: [PaymentID] }
          : null),
        creditorDebtorID: event,
        companyID: CompanyID,
        refTable: 'AP_Payment',
        skip: 0, // or any dynamic value
        take: 20,
      },
    })
  }

  //Favorite Payment functions
  const handleAddFavorite = () => {
    setOpenFavoriteDialog(true)
  }

  const handleSelectFavorite = data => {
    fetchGetCreditorAccountCompanyAssignmentPaginatedListing()

    fetchBankAccount({
      variables: {
        CompanyID: CompanyID,
        RecordStatus: RecordStatus?.Active,
      },
    })

    fetchPaymentMethod()
    fetchCreditCardType()

    setValue('RefNo', data?.RefNo)

    setValue('CreditorAccountID', data?.CreditorAccountID)
    setCreditorAccID(data?.CreditorAccountID)
    handleCreditorDebtorChange(data?.CreditorAccountID)

    setValue('PaymentMethodID', data?.PaymentMethodID)
    setPaymentMethodID(data?.PaymentMethodID)

    setValue('CreditCardID', data?.CreditCardID)
    setCreditCardID(data?.CreditCardID)

    setValue('BankAccountID', data?.BankAccountID)
    setBankAccountID(data?.BankAccountID)

    setValue('Description', data?.Description)
    setValue('Remark', data?.Remark)
  }

  const getAllocationTotal = () => {
    const allocations = watch('Allocation') || []

    if (watch('CreditorAccountID') && allocations.length > 0) {
      return allocations
        .filter(a => a?.CreditOrDebit === 'Credit' && a?.IsChecked)
        .reduce((sum, a) => sum + (Number(a?.AllocationAmt) || 0), 0)
    }

    return 0
  }

  const totalAmt =
    fields?.filter(x => x?.AllocationID)?.length > 0
      ? fields?.reduce(
          (total, currentValue) =>
            (total =
              total +
              Number(currentValue.BalanceAmt) +
              Number(currentValue.AllocationAmt)),
          0
        )
      : fields?.reduce(
          (total, currentValue) =>
            (total = total + Number(currentValue.BalanceAmt)),
          0
        )

  const getAllocChecking = () => {
    if (
      watch('Allocation')?.filter(alloc => Number(alloc?.AllocationAmt))
        ?.length === 0 ||
      watch('DocAmt') > parseFloat(totalAmt.toFixed(2)) ||
      watch('Allocation')?.find(
        alloc =>
          Number(alloc?.AllocationAmt) > parseFloat(totalAmt.toFixed(2)) &&
          parseFloat(totalAmt.toFixed(2)) !== 0
      ) ||
      watch('Allocation') === undefined ||
      docAmt < 0
    ) {
      return true
    } else return false
  }

  function allocateFIFO(
    data: AllocationInput[],
    paymentID?: string
  ): AllocationOutput[] {
    const result: AllocationOutput[] = []

    // Shallow copy untuk mutate
    const credits = data
      .filter(d => d.CreditOrDebit === 'Credit')
      .sort(
        (a, b) => new Date(a.DocDate).getTime() - new Date(b.DocDate).getTime()
      )
      .map(d => ({ ...d }))

    // ✅ Debit = CN yang IsChecked saja
    const debits = data
      .filter(d => d.CreditOrDebit === 'Debit' && d.IsChecked)
      .sort(
        (a, b) => new Date(a.DocDate).getTime() - new Date(b.DocDate).getTime()
      )
      .map(d => ({ ...d }))

    // ✅ Step 1: Allocate CN to Invoice
    for (const debit of debits) {
      // Use the partial AllocationAmt entered by user
      let remaining =
        debit?.BalanceAmt == debit?.AllocationAmt
          ? debit.BalanceAmt
          : debit?.AllocationAmt
      if (remaining <= 0) continue

      for (const credit of credits) {
        if (credit.BalanceAmt <= 0) continue

        const allocAmt = Math.min(remaining, credit.AllocationAmt)

        if (allocAmt > 0) {
          result.push({
            AllocationAmt: allocAmt,
            CompanyID: CompanyID,
            CreditID: credit.CreditID,
            CreditRefTable: credit.CreditRefTable,
            DebitID: debit.DebitID,
            DebitRefTable: debit.DebitRefTable,
            SourceID: paymentID,
            SourceRefTable: 'AP_Payment',
          })

          credit.AllocationAmt -= allocAmt
          remaining -= allocAmt
          if (remaining <= 0) break
        }
      }
    }

    // ✅ Step 2: Remaining Invoice balance → PaymentID
    for (const credit of credits) {
      if (credit.BalanceAmt > 0) {
        result.push({
          CompanyID: CompanyID,
          CreditID: credit.CreditID,
          CreditRefTable: credit.CreditRefTable,
          DebitID: paymentID,
          DebitRefTable: 'AP_Payment',
          AllocationAmt:
            credit.BalanceAmt == credit.AllocationAmt
              ? credit.BalanceAmt
              : credit.AllocationAmt,
          SourceID: paymentID,
          SourceRefTable: 'AP_Payment',
        })
      }
    }

    return result
  }

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  /* -------------------------------------------- */
  /*                   USEEFFECT                  */
  /* -------------------------------------------- */

  useEffect(() => {
    const newAllocatedObj = {}

    if (editData?.AllocationWithAllocatedDoc) {
      editData?.AllocationWithAllocatedDoc?.forEach(doc => {
        const amt = Number(doc?.AllocationAmt ?? 0)

        // ✅ CN allocation → to CN's DebitID
        if (
          doc.DebitRefTable &&
          doc.DebitRefTable.includes('CreditNote') &&
          doc.DebitID
        ) {
          if (!newAllocatedObj[doc.DebitID]) {
            newAllocatedObj[doc.DebitID] = amt
          } else {
            newAllocatedObj[doc.DebitID] += amt
          }
          // If the allocation amount is equal to the balance amount
          if (!newAllocatedObj[doc.CreditID]) {
            newAllocatedObj[doc.CreditID] = amt
          } else {
            newAllocatedObj[doc.CreditID] += amt
          }
        }

        // ✅ Payment allocation → to Invoice's CreditID
        else if (
          doc.DebitRefTable &&
          doc.DebitRefTable.includes('Payment') &&
          doc.CreditID
        ) {
          if (!newAllocatedObj[doc.CreditID]) {
            newAllocatedObj[doc.CreditID] = amt
          } else {
            newAllocatedObj[doc.CreditID] += amt
          }
        }

        // ❌ else ignore (other types)
      })

      setAllocatedObj(newAllocatedObj)
    }
  }, [editData])

  useEffect(() => {
    if (editData?.CreditorAccountID) {
      loadAllocationDocument({
        variables: {
          entityID: PaymentID,
          creditorDebtorID: editData?.CreditorAccountID,
          companyID: CompanyID,
          refTable: 'AP_Payment',
          skip: 0, // or any dynamic value
          take: 20,
        },
      })
    }
  }, [allocatedObj, editData])

  // Edit Bank Account
  useEffect(() => {
    if (!!editData && !!getBankAccount) {
      setSelectedBank(
        getBankAccount?.find(e => e?.BankAccountID === editData?.BankAccountID)
      )
    }
  }, [editData, getBankAccount])

  /* -------------------------------------------- */
  /*                  ATTACHMENT                  */
  /* -------------------------------------------- */
  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    loadDoc,
    { loading: DocLoad, error: DocError, data: DocData },
  ] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  useEffect(() => {
    if (!DocLoad && formMode !== 'add') {
      loadDoc({ variables: { refID: PaymentID } })
    }
    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [formMode, PaymentID, editData])

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? false : true
  const checkingYearClose2 = openPeriod2 ? false : true

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      getAllocChecking() || checkingYearClose2
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccPayablePaymentDraft,
          }),
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.RefNo ||
      !!errors?.CreditorAccountID ||
      !!errors?.PaymentMethodID ||
      !!errors?.BankAccountID ||
      !!errors?.Description ||
      checkingYearClose2
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccPayablePaymentUpdate,
          }),
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {
      handleSubmit(data =>
        getDocumentNumberHeader?.filter(x => x?.RefTable === 'AP_Payment')
          ?.length === 0
          ? (setOpenSnackBar(true),
            setSnackBarMsg(SystemMsgs.errorNumberingStructure()))
          : !createUpdateCalled && onSubmit(data, 'submit')
      )()
      setIsSubmit(true)
    },
    color: 'primary',

    props: {
      type: 'submit',
    },
    disabled: checkingYearClose2 === true || getAllocChecking(),
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      formMode: formMode,
      // for attachment
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
      // for allocation
      hasAllocation: true,
    })

  useEffect(() => {
    setRefresh(true)
    if (mode === 'edit') {
      setValue('CreditorAccountID', editData?.CreditorAccountID)
      fetchGetCreditorAccountCompanyAssignmentPaginatedListing({
        variables: {
          CompanyID,
          CreditorAccountID: editData?.CreditorAccountID,
        },
      })
    } else {
      setValue('CreditorAccountID', null)
      fetchGetCreditorAccountCompanyAssignmentPaginatedListing()
    }

    fetchBankAccount({
      variables: {
        CompanyID: CompanyID,
        RecordStatus: RecordStatus?.Active,
      },
    })

    fetchPaymentMethod()

    fetchCreditCardType()
  }, [])

  return (
    <>
      {bankAccountLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {createUpdateLoading && <Loading />}
      {PaymentMethodLoading && <Loading />}
      {CreditCardTypeLoading && <Loading />}
      {createAPPaymentLoading && <Loading />}
      {updateAPPaymentLoading && <Loading />}
      {FavoritePaymentLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}
      {getAllocationDocumentLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}
      {FavoritePaymentLoading && <Loading />}
      {createAPFavoritePaymentLoading && <Loading />}
      {deleteAPFavoritePaymentLoading && <Loading />}
      {FetchGetCreditorAccountCompanyAssignmentPaginatedLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : history.push(`/account-payable/${CompanyID}/payment`)
          localStorage.removeItem('DebitAmt')
        }}
        smTitle={'Account Payable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Payable' },
          { name: 'AP Submenu' },
          { name: 'Payment Listing' },
          { name: 'Payment', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              mode === 'add'
                ? 'New'
                : mode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <InfiniteScroll
          scrollableTarget="scroll-wrapper"
          dataLength={fields.length}
          next={() => {
            // if (!hasMore || allocationDocumentLoading) return
            if (creditorAccID) {
              loadAllocationDocument({
                variables: {
                  entityID: editData ? editData?.PaymentID : null,
                  companyID: CompanyID,
                  refTable: 'AP_Payment',
                  skip: skip,
                  take: take,
                  creditorDebtorID: creditorAccID,
                },
              })
            }
          }}
          hasMore={hasMore}
          loader={
            getAllocationDocumentLoading && (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            )
          }
        >
          <CardContents
            section={{
              header: {
                title: 'Payment',
                icon: (
                  <FavoriteMenu
                    options={getAPFavoritePayment}
                    funcLabel={'Add Favorite'}
                    addFavFunc={handleAddFavorite}
                    selectFavFunc={handleSelectFavorite}
                    optionIDName={'FavoritePaymentID'}
                    setOpenFavoriteDeleteDialog={setOpenFavoriteDeleteDialog}
                    anchorEl={anchorElFav}
                    setAnchorEl={setAnchorElFav}
                    handleClose={handleCloseFav}
                    handleClickDelete={handleClickFav}
                  />
                ),
              },
            }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                required
                className="left"
                as={KeyboardDatePicker}
                name="DocDate"
                label="Date"
                control={control}
                onChange={(date: Date | null) => {}}
                format="dd/MM/yyyy"
                value={watch(
                  formMode === 'add' ? new Date() : editData?.DocDate
                )}
                margin="dense"
                allowKeyboardControl
                ref={register}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                defaultValue={editData ? editData?.DocDate : new Date()}
                showTodayButton
                disabled={mode == 'approve-reject'}
                style={{
                  paddingTop: '10px',
                }}
                // minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
                // maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
                // helperText={
                //   checkingYearClose1
                //     ? 'Financial Period already closed'
                //     : errors?.DocDate?.message
                // }
                // error={errors?.DocDate || checkingYearClose1 ? true : false}
              />
            </MuiPickersUtilsProvider>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                as={KeyboardDatePicker}
                name="TrxDate"
                required
                label="Transaction Date"
                control={control}
                format="dd/MM/yyyy"
                margin="normal"
                allowKeyboardControl
                onChange={(date: Date | null) => {}}
                ref={register}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                showTodayButton
                className="right"
                value={new Date()}
                defaultValue={editData ? editData?.TransactionDate : new Date()}
                minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
                maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
                helperText={
                  checkingYearClose2
                    ? 'Financial Period already closed'
                    : errors?.TrxDate?.message
                }
                error={errors?.TrxDate || checkingYearClose2 ? true : false}
              />
            </MuiPickersUtilsProvider>
            <Controller
              as={TextField}
              id="standard-basic"
              name="RefNo"
              label="Reference No."
              required
              autoComplete="off"
              control={control}
              margin="dense"
              className="left"
              ref={register}
              helperText={errors?.RefNo?.message}
              error={errors?.RefNo ? true : false}
              defaultValue={editData ? editData?.RefNo : ''}
              disabled={mode == 'approve-reject'}
            />
            <Controller
              render={({ onChange }) => (
                <NumberFormat
                  InputProps={{
                    readOnly: true,
                  }}
                  allowNegative={true}
                  customInput={TextField}
                  decimalScale={2}
                  fixedDecimalScale
                  autoComplete="off"
                  thousandSeparator
                  isNumericString
                  margin="dense"
                  className="right"
                  value={docAmt}
                  label="Amount"
                  defaultValue={editData?.DocAmt ?? 0}
                />
              )}
              customInput={TextField}
              ref={register()}
              control={control}
              margin="dense"
              className="right"
              name="DocAmt"
              label="Amount"
            />

            {!refresh && (
              <Controller
                name="CreditorAccountID"
                ref={register()}
                control={control}
                defaultValue={editData?.CreditorAccountID}
                render={({ onChange, value }) => {
                  const selectedItem = creditorAccounts?.find(
                    item =>
                      item?.CreditorAccountID === watch('CreditorAccountID')
                  )
                  return (
                    <PaginatedAutocomplete
                      required
                      label="Creditor Name"
                      searchVariable="searchValue"
                      fetchMoreOptions={
                        fetchGetCreditorAccountCompanyAssignmentPaginatedListing
                      }
                      setOptions={setCreditorAccounts}
                      options={creditorAccounts || []}
                      totalLength={totalCreditorAccounts}
                      setValue={setValue}
                      name="CreditorAccountID"
                      optionsLoading={
                        FetchGetCreditorAccountCompanyAssignmentPaginatedLoading
                      }
                      getOptionLabel={option => `${option?.CompanyName}`}
                      fullWidth
                      value={selectedItem}
                      onChange={(event, newValue) => {
                        setRefresh(false)

                        if (!newValue || !newValue?.CreditorAccountID) {
                          setValue('CreditorAccountID', null)
                          setCreditorAccID(null)
                          return
                        }

                        setValue(
                          'CreditorAccountID',
                          newValue?.CreditorAccountID
                        )
                        setCreditorAccID(newValue?.CreditorAccountID)
                        handleCreditorDebtorChange(newValue?.CreditorAccountID)
                        onChange(newValue?.CreditorAccountID)
                      }}
                      renderOption={(props, option) => {
                        return <span>{props?.CompanyName}</span>
                      }}
                    />
                  )
                }}
              />
            )}

            <Controller
              render={({ onChange, value }) => (
                <TextField
                  label="Payment Method"
                  required
                  select
                  value={value}
                  margin="dense"
                  onChange={e => {
                    onChange()
                    handlePMChange(e)
                    setValue('PaymentMethodID', e?.target?.value)
                  }}
                  defaultValue={
                    editData ? editData?.PaymentMethodID : paymentMethodID ?? ''
                  }
                  disabled={formMode === 'approve-reject'}
                  helperText={errors?.PaymentMethodID?.message}
                  error={errors?.PaymentMethodID ? true : false}
                >
                  {getPaymentMethod
                    ?.sort((a, b) => {
                      return a.Name.localeCompare(b.Name)
                    })
                    .map((el, index) => (
                      <MenuItem key={index} value={el.PaymentMethodID}>
                        {el.Name}
                      </MenuItem>
                    ))}
                </TextField>
              )}
              control={control}
              helperText={errors?.PaymentMethodID?.message}
              error={errors?.PaymentMethodID ? true : false}
              onChange={e => {
                //handlePMChange(e)
                setValue('PaymentMethodID', e?.target?.value)
              }}
              ref={register()}
              name="PaymentMethodID"
              autoComplete="off"
              value={editData?.PaymentMethodID}
              margin="dense"
              multiline={true}
              fullWidth
              required
            />

            {getPaymentMethod
              .find(el => el.PaymentMethodID === watch('PaymentMethodID'))
              ?.Name?.includes('Card') && (
              <Controller
                render={({ onChange, value }) => (
                  <TextField
                    select
                    required
                    name="CreditCardID"
                    margin="dense"
                    label="Card Type"
                    onChange={e => {
                      onChange(e)
                      handleCCChange(e)
                      //setValue('CreditCardID', e?.target?.value)
                    }}
                    defaultValue={
                      editData ? editData?.CreditCardID : creditCardID ?? ''
                    }
                    disabled={mode == 'approve-reject'}
                    // helperText={errors?.CreditCardID?.message}
                    // error={errors?.CreditCardID ? true : false}
                  >
                    {getCreditCardType
                      ?.sort((a, b) => {
                        return a.Name.localeCompare(b.Name)
                      })
                      .map((el, index) => (
                        <MenuItem key={index} value={el.CreditCardID}>
                          {`${el.Name}`}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
                label="Card Type"
                name="CreditCardID"
                autoComplete="off"
                control={control}
                helperText={errors?.CreditCardID?.message}
                error={errors?.CreditCardID ? true : false}
                multiline={true}
                defaultValue={editData?.CreditCardID ?? creditCardID}
                fullWidth
                margin="dense"
                ref={register}
              />
            )}

            {getPaymentMethod.find(
              el => el.PaymentMethodID === watch('PaymentMethodID')
            )?.Name === 'Cheque' && (
              <>
                <Controller
                  as={TextField}
                  id="standard-basic"
                  name="ChequeNo"
                  label="Cheque No"
                  className="left"
                  required
                  autoComplete="off"
                  control={control}
                  margin="dense"
                  ref={register}
                  // helperText={errors?.ChequeNo?.message}
                  // error={errors?.ChequeNo ? true : false}
                  defaultValue={editData ? editData?.ChequeNo : ''}
                  disabled={mode == 'approve-reject'}
                />

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Controller
                    required
                    as={KeyboardDatePicker}
                    name="ChequeDate"
                    label="Cheque Date"
                    control={control}
                    onChange={(date: Date | null) => {}}
                    format="dd/MM/yyyy"
                    value={
                      // formMode === 'add' ? new Date() : editData?.ChequeDate
                      watch('ChequeDate')
                    }
                    margin="dense"
                    allowKeyboardControl
                    ref={register}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    defaultValue={
                      formMode === 'add' ? new Date() : editData?.ChequeDate
                    }
                    showTodayButton
                    className="right"
                    disabled={mode == 'approve-reject'}
                    // helperText={errors?.ChequeDate?.message}
                    // error={errors?.ChequeDate ? true : false}
                  />
                </MuiPickersUtilsProvider>
              </>
            )}

            <DropdownTextfield
              // mount={bankNameNeeded}
              disabled={formMode === 'approve-reject' ? true : false}
              helperText={errors?.BankAccountID?.message}
              error={errors?.BankAccountID ? true : false}
              label="Company Bank Account No."
              handleChangeEnabled
              handleChange={handleBankChange}
              selectProps={{
                renderValue: () =>
                  `${
                    getBankAccount?.find(
                      x => x?.BankAccountID === watch('BankAccountID')
                    )?.AccountNo
                  } (${
                    getBankAccount?.find(
                      x => x?.BankAccountID === watch('BankAccountID')
                    )?.BankProfile?.Name
                  })`,
              }}
              customDropdown={getBankAccount?.map((el, index) => (
                <MenuItem
                  id="contract-select"
                  key={index}
                  value={el?.BankAccountID}
                >
                  <div className="content-wrap full">
                    <div>
                      <span className="xsTitle">
                        {el.BankProfile?.Name} ({el.BankProfile?.Address?.city})
                      </span>
                    </div>
                    <div className="desc">
                      Account No: {`${el?.AccountNo} (${el?.Code})`}
                    </div>
                  </div>
                </MenuItem>
              ))}
              name="BankAccountID"
              control={control}
              register={register}
              defaultValue={bankAccountID ?? ''}
            />

            <Controller
              as={TextField}
              id="standard-basic"
              name="Description"
              label="Description"
              required
              autoComplete="off"
              control={control}
              fullWidth
              margin="dense"
              helperText={errors?.Description?.message}
              error={errors?.Description ? true : false}
              ref={register}
              defaultValue={
                formMode === 'edit' || mode === 'approve-reject'
                  ? editData?.Description
                  : ''
              }
              disabled={mode === 'approve-reject'}
            />

            <VoiceTextField
              mounted={true}
              label="Remark"
              name="Remark"
              value={voiceRemark}
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              control={control}
              controllerProps={{
                error: errors?.Remark ? true : false,
                helperText: errors?.Remark?.message,
                ref: register,
                autoComplete: 'off',
              }}
            />

            <DocUploadInput
              placeholder={previewFiles.length === 0 ? 'Attachment' : null}
              label={previewFiles.length > 0 ? 'Attachment' : null}
              files={files}
              onHandleUploadChange={handleUploadChange}
              multiple
              accept={
                '.png, .jpg, .jpeg, .gif, .mp4, .avi, .mkv, .mov, .flv, .3gp, application/msword, application/pdf, application/vnd.ms-excel, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              }
              mapData={'application'}
              imagePreview={
                <>
                  {previewFiles?.map((v, i) => (
                    <UploadPreview
                      remove
                      key={v}
                      src={v}
                      onClick={() => removeFile(i)}
                      mediaType={
                        // files[i]?.type
                        files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                      }
                    />
                  ))}
                </>
              }
              disabled={mode === 'approve-reject'}
            />
          </CardContents>

          {creditorAccID !== null && (
            <PaymentAllocationTableContent
              fields={fields}
              watch={watch}
              errors={errors}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              setError={setError}
              allocatedObj={allocatedObj}
              docAmt={docAmt}
              setDocAmt={setDocAmt}
              totalAmt={getAllocationTotal()}
              headerStyle={{
                backgroundColor: '#faf2e8',
                color: '#ff9800',
                fontWeight: '700',
              }}
              hasCheckbox={true}
              companyID={CompanyID}
            />
          )}
        </InfiniteScroll>
      </ContentWrapper>

      {footerOptions?.length > 0 ? (
        <AccountFooter options={[...footerOptions]} />
      ) : null}

      <TotalAmountFooter docAmt={docAmt ?? 0} />

      <CommonDialog
        fullWidth={true}
        open={openExitDialog}
        onClose={() => setopenExitDialog(false)}
        sections={{
          header: {
            title: 'Exit Confirmation',
          },
          body: () => (
            <>
              <div>
                Are you sure you want to exit? Your changes will not be saved.
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setopenExitDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => history.goBack(),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />

      <AddFavoriteDialog
        openFavoriteDialog={openFavoriteDialog}
        setOpenFavoriteDialog={setOpenFavoriteDialog}
        favRegister={favRegister}
        favControl={favControl}
        favNames={favNames}
        favErrors={favErrors}
        favWatch={favWatch}
        dialogTitle={'Payment Detail'}
        handleFavSubmit={handleFavSubmit}
        onSubmitFavorite={onSubmitFavorite}
      />

      <DeleteFavoriteDialog
        openFavoriteDeleteDialog={openFavoriteDeleteDialog}
        setOpenFavoriteDeleteDialog={setOpenFavoriteDeleteDialog}
        dialogTitle={'Favorite Payment Entry'}
        menuFav={menuFav}
        deleteMutation={deleteAPFavoritePayment}
        favRefetchQuery={favRefetchQuery}
        favID={menuFav?.ID}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-payable/${CompanyID}/payment`)
        }}
      />
    </>
  )
}
